import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  AccordionItem,
  AccordionBody,
  AccordionHeader,
  UncontrolledAccordion,
} from "reactstrap";
import { connect } from "react-redux";
// components
import Flight from "./flight";
import Tranfers from "./transfer";
import Hotel from "./hotel";
// service
import { getParticipantsLogistic } from "../../../../utils/services/participants";

function ModalViewLogistics(props) {
  const { isOpen, toggle, idEvent, user } = props;
  // participantes
  const [participants, setParticipants] = useState([]);

  // busca os participantes com logística do evento
  function getDataParticipants() {
    getParticipantsLogistic({
      idEvent: idEvent,
      offset: 0,
      limit: 0,
      search: "",
    }).then((res) => {
      if (res?.data?.count > 0) {
        setParticipants(res.data.data);
      } else setParticipants([]);
    });
  }

  // verifica se o produto está habilitado no evento
  function checkItemMenuExists(menuOption) {
    return (
      props.foundProducts.filter((item) => item.name === menuOption).length > 0
    );
  }

  useEffect(() => {
    getDataParticipants();
  }, []);

  return (
    <Modal isOpen={isOpen} centered size="lg">
      <ModalHeader toggle={toggle}>
        Logística do(a) Participante {user?.nome ? user.nome : ""}
      </ModalHeader>
      <ModalBody>
        <UncontrolledAccordion flush>
          {checkItemMenuExists("VOO") && (
            <AccordionItem>
              <AccordionHeader targetId="1">Voo</AccordionHeader>
              <AccordionBody accordionId="1">
                <Flight
                  idEvent={idEvent}
                  participants={participants}
                  user={user}
                />
              </AccordionBody>
            </AccordionItem>
          )}

          {checkItemMenuExists("TRANSFER") && (
            <AccordionItem>
              <AccordionHeader targetId="2">Transfer</AccordionHeader>
              <AccordionBody accordionId="2">
                <Tranfers
                  idEvent={idEvent}
                  participants={participants}
                  user={user}
                />
              </AccordionBody>
            </AccordionItem>
          )}

          {checkItemMenuExists("HOTEL") && (
            <AccordionItem>
              <AccordionHeader targetId="3">Hotel</AccordionHeader>
              <AccordionBody accordionId="3">
                <Hotel
                  idEvent={idEvent}
                  participants={participants}
                  user={user}
                />
              </AccordionBody>
            </AccordionItem>
          )}
        </UncontrolledAccordion>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  foundProducts: state.global_user_data.data.foundProducts,
});

export default connect(mapStateToProps)(ModalViewLogistics);
